import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './ProductSlider.css'; // Make sure to style Swiper here
import 'swiper/css';
import { Autoplay, Navigation } from 'swiper/modules';
import axios from 'axios';
const ProductSlider = () => {
  const images = [
    {
      src: './assets/slider-images/1.png',
      text: 'Tyler Watson',
      text2: '$400K+ in revenue with organic leads.',
      text3: '75% Increase in Reach',
      text4: '80% Rise in Engagement',
    },
    {
      src: './assets/slider-images/2.png',
      text: 'Jason Starling',
      text2: '0 to a thriving FB group and YT Channel',
      text3: '70% Rise in FB Engagement',
      text4: 'Gained 60% More Time for Key Tasks',
    },
    {
      src: './assets/slider-images/3.png',
      text: 'Justin Morgan',
      text2: 'Built a Thriving Community with Organic Content',
      text3: '30% Increase in Monthly Meetup Attendance',
      text4: '40% Boost in Local Awareness',
    },
    ,
    {
      src: './assets/slider-images/4.png',
      text: 'Lydia Martinez Ebling',
      text2: 'Elevated Content Quality with Professional Edits',
      text3: '40% Increase in Reach',
      text4: 'Focused on New Product Launches',
    },
    {
      src: './assets/slider-images/5.png',
      text: 'Christopher Vos',
      text2: 'Boosted Audience Visibility and Service Awareness',
      text3: '30% Increase in Reach',
      text4: 'Streamlined Biz Systems',
    },
    {
      src: './assets/slider-images/6.png',
      text: 'Sahil Sehgal',
      text2: 'Generated $350k+ revenue running challenges',
      text3: 'Attracted 3K+ leads via content',
      text4: 'Nurture audience for HighTicket offer',
    },
    {
      src: './assets/slider-images/7.png',
      text: 'Ryan D. Lee',
      text2: 'Attracted potential clients with strategic content',
      text3: '40% increase in engagement',
      text4: '50% boost in content reach',
    },
    {
      src: './assets/slider-images/8.png',
      text: 'Nikhil Sai',
      text2: 'Edited high-impact videos for Ad campaigns',
      text3: 'Boosted lead quality and Ad conversions',
      text4: 'Reduced Ads costs with engaging video',
    },
    {
      src: './assets/slider-images/9.png',
      text: 'ZUKR',
      text2: 'Achieved 1M+ content views, boosting brand awareness',
      text3: 'Grew 10x newsletter subscribers',
      text4: 'Launched a dream recipe book',
    },
    {
      src: './assets/slider-images/10.png',
      text: 'Rebecca Kordecki',
      text2: 'Attracted quality leads for breathwork sessions',
      text3: 'Boosted service awareness',
      text4: 'Imporived high-quality content',
    },
    {
      src: './assets/slider-images/11.png',
      text: 'Tiffany Marshall',
      text2: 'Launched beta coaching program and secured clients',
      text3: '20% boost in facebook group growth',
      text4: 'Content creation to enhance visibility',
    },
    {
      src: './assets/slider-images/12.png',
      text: 'Morgana McCabe Allan',
      text2: 'Consistent leads for events with quality content',
      text3: 'Enhanced brand visibility',
      text4: '50-60% increased reach',
    },
    // new added by kamal
    {
      src: './assets/slider-images/13.jpg',
      text: 'Hilary DeCesare',
      text2: 'Amplified visibility & engagement for Relaunch to a Rich Life event',
      text3: '+44.9% increase in reach',
      text4: '+80.6% growth in engagement',
    },
  ];

  return (
    <>
      <Swiper
        centeredSlides={true}
        slidesPerView={3}
        loop={true}
        autoplay={{
          delay: 0,
          disableOnInteraction: true,
        }}
        speed={5000}
        spaceBetween={-30} // Add gap between slides
        modules={[Autoplay, Navigation]}
        className='mySwiper2'
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: -30,
          },
        }}
      >
        {Array.from({ length: 2 }).map((_, index) => (
          <React.Fragment key={'fragment' + index}>
            {images.map((image, idx) => (
              <SwiperSlide key={'slider' + idx + Math.floor(Math.random() * new Date().getTime())} className='product-slide'>
                <div className='image-wrapper' key={idx}>
                  <img
                    src={image.imageUrl || image.src}
                    alt={`Slide ${idx + 1}`}
                    className='slider-image'
                  />
                  <div className='image-text'>{image.text}</div>
                  <div className='image-text2'>{image.text2}</div>
                  <div className='text-container'>
                    <div className='image-text3'>{image.text3}</div>
                    <div className='image-text4'>{image.text4}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </React.Fragment>
        ))}
      </Swiper>
    </>
  );
};

export default ProductSlider;
